import React from "react";
import NumberSpinner from "../NumberSpinner/NumberSpinner";
import RateSelect from "../Selects/RateSelect";
import ReservationsSegmentCheckInRoomSelect from "../ReservationSegmentCheckIn/ReservationsSegmentCheckInRoomSelect";
import ReservationBuilderActions from "./actions/ReservationBuilderActions";
import DateHelper from "../DateHelper/DateHelper";
import numeral from "numeral";

export default class ReservationBuilderSegment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      numberFormat:
        "0" +
        ($("#delimiter").val() || ",") +
        "0" +
        ($("#separator").val() || ".") +
        "00",
    };
    this.onChange = this.onChange.bind(this);
    this.onChangeRate = this.onChangeRate.bind(this);
    this.onChangeRoom = this.onChangeRoom.bind(this);
    this.onChangeGuestTypeCount = this.onChangeGuestTypeCount.bind(this);
    this.onClose = this.onClose.bind(this);
    this.onOpen = this.onOpen.bind(this);
    this.onRemove = this.onRemove.bind(this);
  }

  /**
   * Render functions
   */

  render() {
    var self = this;
    var guest_types = this.props.guest_types.map(function (guest_type) {
      return (
        <div className="row guest-type-form" key={guest_type.id}>
          <div className="col-sm-5 guest-type-label">
            <div className="name">
              {guest_type.name} ({self.renderAgeRange(guest_type)})
            </div>
          </div>
          <div className="col-sm-7 guest-type-number-spinner">
            <NumberSpinner
              name={guest_type.id}
              onChange={self.onChangeGuestTypeCount}
              value={self.getGuestCount(guest_type.id)}
            />
          </div>
        </div>
      );
    });

    var room_label = "room";
    var room = this.props.segment.room;
    var room_group = false;

    if (this.props.segment.room_type.type_of_booking == "room_group") {
      room_label = "room_group";
      room = this.props.segment.room_group;
      room_group = true;
    }

    if (
      this.props.segment.room_id === null ||
      this.props.segment.room_id === ""
    ) {
      room = null;
    }

    return (
      <div className="reservation-segment">
        <div className="header">
          <div style={{ marginRight: "88px" }}>
            {this.renderArrow()}

            {DateHelper.printDateToScreen(
              this.props.segment.check_in_date,
              DateHelper.rubyToDateFNS(this.props.date_format)
            )}
            {this.props.segment.room_type.type_of_booking !== 'daily' ? '\u00A0\u2013\u00A0' : null}
            {
              this.props.segment.room_type.type_of_booking == 'daily'
                ?
                null
                :
                DateHelper.printDateToScreen(
                  this.props.segment.check_out_date,
                  DateHelper.rubyToDateFNS(this.props.date_format)
                )
            }{" "}
            &nbsp;
            <strong>
              <a
                href={`/admin/room_types/${this.props.segment.room_type.id}`}
                className="modal-iframe"
                data-fullscreen="true"
              >
                {this.props.segment.room_type.name}
              </a>
            </strong>
            &nbsp; (
            {this.props.segment.rate ? (
              <strong>
                <a
                  href={`/admin/rates/${this.props.segment.rate.id}`}
                  className="modal-iframe"
                  data-fullscreen="true"
                >
                  {this.props.segment.rate.code}
                </a>
              </strong>
            ) : null}
            )&nbsp;
            {this.props.segment.subtotal_amount
              ? " $" +
              numeral(this.props.segment.subtotal_amount / 100).format(
                this.state.numberFormat
              )
              : null}
            &nbsp;
            {/* {this.renderRatesSelect()} */}
          </div>
          <button
            type="button"
            className="btn btn-sm btn-secondary remove"
            onClick={this.onRemove}
          >
            {I18n.t("remove")}
          </button>
        </div>
        <div
          className="body"
          ref="body"
          style={{ display: this.state.open ? "block" : "none" }}
        >
          <div className="row">
            <div className="col-sm-6 reservation-segment-room-select">
              <div className="form-group">
                <label>{I18n.t(room_label)}</label>
                <ReservationsSegmentCheckInRoomSelect
                  name="room_id"
                  connected_room_format={true}
                  selectorId={this.props.segment.id}
                  room_id={
                    this.props.segment.room_id || this.props.room_group_id
                  }
                  room={room}
                  allowClear={true}
                  room_type={this.props.segment.room_type}
                  onChange={this.onChangeRoom}
                  room_group={room_group}
                  dateFormat={this.props.date_format}
                  check_in_date={this.props.segment.check_in_date}
                  check_out_date={this.props.segment.check_out_date}
                  taken_room_types={this.props.taken_room_types}
                  taken_room_ids={this.props.taken_room_ids}
                  room_type_segments={this.props.room_type_segments}
                  booking_occupied_room_types={
                    this.props.booking_occupied_room_types
                  }
                  booking_occupied_room_ids={
                    this.props.booking_occupied_room_ids
                  }
                  source="ReservationBuilder"
                />
              </div>
            </div>
            <div className="col-sm-6 reservation-segment-guest-types">
              <label>{I18n.t("guest_types")}</label>
              {this.isMaxOccupancyReached() ? (
                <p>
                  {I18n.t("max_occupancy_reached", {
                    max_occupancy:
                      this.props.segment.room_type.maximum_occupancy,
                  })}
                </p>
              ) : null}
              {guest_types}
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <div className="form-group">
                <label>
                  {I18n.t("room_notes")}{" "}
                  <span
                    className="ss-help"
                    title={I18n.t("room_notes_helper_text")}
                  ></span>
                </label>
                <textarea
                  name="notes"
                  value={this.props.segment.notes}
                  className="form-control notes"
                  onChange={this.onChange}
                ></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderArrow() {
    if (this.state.open) {
      return (
        <div className="toggle-arrow arrow-down" onClick={this.onClose}></div>
      );
    } else {
      return (
        <div className="toggle-arrow arrow-right" onClick={this.onOpen}></div>
      );
    }
  }

  renderAgeRange(guest_type) {
    if (
      guest_type.maximum_age == null ||
      typeof guest_type.maximum_age == "undefined"
    ) {
      return <span>{guest_type.minimum_age}+</span>;
    } else {
      return (
        <span>
          {guest_type.minimum_age} &ndash; {guest_type.maximum_age}
        </span>
      );
    }
  }

  renderRatesSelect() {
    var self = this;

    if (this.props.segment.room_type && this.props.segment.room_type.rates) {
      return (
        <div>
          <hr style={{ marginBottom: 12 }} />
          <div className="form-group" style={{ marginBottom: 0 }}>
            <label>{I18n.t("rate")}</label>
            <RateSelect
              name="rate"
              selectID={this.props.segment.id}
              promo_code={this.props.promo_code}
              start_date={this.props.segment.check_in_date}
              end_date={this.props.segment.check_out_date}
              rate={this.props.segment.rate}
              group_contract={this.props.group_contract}
              room_type={this.props.segment.room_type}
              onChange={this.onChangeRate}
            />
          </div>
        </div>
      );
    } else {
    }
  }

  /**
   * Change handlers
   */

  onChangeGuestTypeCount(event) {
    ReservationBuilderActions.updateSegmentGuestCount(
      this.props.segment,
      event.target.name,
      event.target.value
    );
  }

  onChangeRate(rate) {
    var segment = this.props.segment;
    segment.rate_id = rate.id;
    ReservationBuilderActions.updateSegment(segment);
  }

  onChangeRoom(room) {
    var segment = this.props.segment;

    if (room === null || room.id === "unassigned") {
      segment.room_id = null;
      segment.room = null;
      segment.room_group_id = null;
      segment.room_group = null;
    } else {
      if (room.room_group) {
        segment.room_group_id = room.id;
      } else {
        segment.room_id = room.id;
      }
    }

    ReservationBuilderActions.updateSegment(segment);
  }

  onChange(event) {
    var segment = this.props.segment;
    segment[event.target.name] = event.target.value;
    ReservationBuilderActions.updateSegment(segment, false);
  }

  onOpen() {
    var self = this;

    $(self.refs.body).slideDown("fast", function () {
      self.setState({ open: true });
    });
  }

  onClose() {
    var self = this;

    $(self.refs.body).slideUp("fast", function () {
      self.setState({ open: false });
    });
  }

  onRemove() {
    var self = this;

    ReservationBuilderActions.removeSegment(self.props.segment.id);

    // var dialog = BootstrapDialog.show({
    //     title: '<h4>' + I18n.t('please_confirm') + '</h4>',
    //     message: '<div class="confirm-modal-body">' + I18n.t('are_you_sure_you_want_to_remove_this_reservation_segment') + '</div>',
    //     buttons: [{
    //         label: I18n.t('remove'),
    //         cssClass: 'btn-primary',
    //         action: function(dialog) {
    //           ReservationBuilderActions.removeSegment(self.props.segment.id);
    //           dialog.close();
    //         }
    //     }, {
    //         label: I18n.t('cancel'),
    //         action: function(dialog) {
    //           dialog.close();
    //         }
    //     }]
    // });
  }

  /**
   * Helper functions
   */

  calculateMaxGuests(guest_type_id) {
    var room_type = this.props.segment.room_type;
    var total_guest_count = 0;
    if (this.props.segment.reservation_segment_guest_types) {
      for (
        var i = 0,
        ilen = this.props.segment.reservation_segment_guest_types.length;
        i < ilen;
        i++
      ) {
        if (
          this.props.segment.reservation_segment_guest_types[i].guest_type_id ==
          guest_type_id
        ) {
          // ignore if the guest_type_id matches
        } else {
          total_guest_count =
            total_guest_count +
            parseInt(
              this.props.segment.reservation_segment_guest_types[i]
                .number_of_guests
            );
        }
      }
    }

    if (room_type && room_type.maximum_occupancy > 0) {
      return room_type.maximum_occupancy - total_guest_count;
    } else {
      return 0;
    }
  }

  getGuestCount(guest_type_id) {
    if (this.props.segment.reservation_segment_guest_types) {
      for (
        var i = 0,
        ilen = this.props.segment.reservation_segment_guest_types.length;
        i < ilen;
        i++
      ) {
        if (
          this.props.segment.reservation_segment_guest_types[i].guest_type_id ==
          guest_type_id
        ) {
          return parseInt(
            this.props.segment.reservation_segment_guest_types[i]
              .number_of_guests
          );
        }
      }
    }
  }

  isMaxOccupancyReached() {
    var room_type = this.props.segment.room_type;
    var total_guest_count = 0;

    if (this.props.segment.reservation_segment_guest_types) {
      for (
        var i = 0,
        ilen = this.props.segment.reservation_segment_guest_types.length;
        i < ilen;
        i++
      ) {
        total_guest_count =
          total_guest_count +
          parseInt(
            this.props.segment.reservation_segment_guest_types[i]
              .number_of_guests
          );
      }
    }

    if (room_type && room_type.maximum_occupancy > 0) {
      return room_type.maximum_occupancy == total_guest_count;
    } else {
      return false;
    }
  }

  rateCurrentUsageCount(rate) {
    currentUsageCount = rate.usage_count;

    for (var i = 0, ilen = this.props.segments.length; i < ilen; i++) {
      var segment = this.props.segments[i];
      if (segment.id != this.props.segment.id && segment.rate_id == rate.id) {
        currentUsageCount++;
      }
    }

    return currentUsageCount;
  }
}
